import { render, staticRenderFns } from "./supplierResourceManageList.vue?vue&type=template&id=bc95566a&scoped=true"
import script from "./supplierResourceManageList.vue?vue&type=script&lang=js"
export * from "./supplierResourceManageList.vue?vue&type=script&lang=js"
import style0 from "./supplierResourceManageList.vue?vue&type=style&index=0&id=bc95566a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc95566a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc95566a')) {
      api.createRecord('bc95566a', component.options)
    } else {
      api.reload('bc95566a', component.options)
    }
    module.hot.accept("./supplierResourceManageList.vue?vue&type=template&id=bc95566a&scoped=true", function () {
      api.rerender('bc95566a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/supplierManage/supplierResourceManageList.vue"
export default component.exports